// pages/Mileage.jsx
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";
import { projects } from "../data/projectsData";

const Mileage = () => (
  <>
    <title>Mileage Calculator - Arthur Efremenko</title>
    <meta name="description" content={projects.mileage.description} />
    <ProjectTemplate
      project={projects.mileage}
      screenshots={projects.mileage.screenshots}
    />
  </>
);

export default Mileage;
